import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import {
    Card,
    CardActions,
    CardHeader,
    CardContent,
    Modal,
    Button,
    TextField,
    Select,
    MenuItem,
    Input,
    InputLabel
} from "@material-ui/core";
// import FormControl from "@material-ui/core/FormControl";
import { hot } from "react-hot-loader";
import {
    selectUserNames,
    selectTempUserPositionsForDay,
    selectJobpackKeys
} from "./selectors";
import {
    setEventRowTitle,
    setDayData,
    setTempUserPosition,
    copyUserPositionsToTempUserPositions,
    clearTempUserPosition
} from "./actions";
import styled from "styled-components";

const EditDayContainer = styled.div`
    height: 450px;
    width: 400px;
    display: grid;
    grid-template-rows: repeat(6, 1fr);
    grid-template-columns: 1fr;
`;

const TextInputContainer = styled.div`
    grid-row-start: ${props => props.row};
    grid-row-end: ${props => props.row};
    grid-column-start: 1;
    grid-column-end: 1;
`;

function getModalStyle() {
    return {
        top: `50%`,
        left: `50%`,
        transform: `translate(-50%, -50%)`,
        overflow: "visible"
    };
}

const styles = theme => ({
    paper: {
        position: "absolute",
        width: theme.spacing.unit * 55,
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing.unit,
        overflow: "visible"
    },

    margin: {
        margin: theme.spacing.unit
    }
});

class EditDayCellModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            jobName: "",
            jobID: "",
            employee1: "",
            employee2: "",
            employee3: "",
            employee4: "",
            userPositions: false
        };
    }

    handleChange = (e, key) => {
        if (key === "jobID") {
            const re = /^[0-9\b]+$/;
            if (
                (e.target.value === "" || re.test(e.target.value)) &&
                e.target.value.length <= 6
            ) {
                this.setState({ jobID: e.target.value });
            }
        } else {
            this.setState({ [key]: e.target.value });
        }
    };

    componentDidUpdate = prevProps => {
        if (this.props.open !== prevProps.open && this.props.open === true) {
            if (this.props.dayCell === false) {
                this.setState({
                    jobName: "",
                    jobID: "",
                    employee1: "",
                    employee2: "",
                    employee3: "",
                    employee4: ""
                });
            } else {
                this.setState({
                    ...this.props.dayCell
                });
            }
        }
    };

    checkEmployeeBelongsInMenuItem = (user, key) => {
        if (user.row === this.props.eventRowIndex && user.key === key) {
            return true;
        }

        if (user === false) {
            return true;
        }
        return false;
    };

    getEmployeeSelect = (key, row) => {
        if (this.props.userPositions === false) {
            return null;
        }

        const userPositions = this.props.userPositions;
        return (
            <TextInputContainer row={row}>
                <InputLabel shrink htmlFor={`age-label-placeholder${key}`}>
                    Operative {row - 2}
                </InputLabel>
                <Select
                    value={this.state[key]}
                    onChange={e => {
                        this.handleChange(e, key);
                        this.props.setTempUserPosition(
                            this.props.dayCellIndex,
                            this.props.eventRowIndex,
                            e.target.value,
                            key
                        );
                    }}
                    input={
                        <Input name="age" id={`age-label-placeholder${key}`} />
                    }
                    inputProps={{
                        name: "age",
                        id: "age-simple"
                    }}
                >
                    <MenuItem value={""}>{"None"}</MenuItem>
                    {Object.keys(userPositions).map((name, i) => {
                        const user = userPositions[name];

                        const result = this.checkEmployeeBelongsInMenuItem(
                            user,
                            key
                        );

                        if (result === true) {
                            return (
                                <MenuItem key={i} value={name}>
                                    {name}
                                </MenuItem>
                            );
                        } else {
                            return null;
                        }
                    })}
                </Select>
            </TextInputContainer>
        );
    };

    render() {
        const { classes } = this.props;

        return (
            <Modal
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                open={this.props.open}
                onClose={this.props.handleClose}
            >
                <Card style={getModalStyle()} className={classes.paper}>
                    <CardHeader title={"Edit Day"} />
                    <CardContent>
                        <EditDayContainer>
                            <TextInputContainer row={1}>
                                <InputLabel shrink htmlFor={`jobpack-id`}>
                                    Job ID
                                </InputLabel>
                                <Select
                                    value={this.state["jobID"]}
                                    onChange={e => {
                                        const result = this.props.jobpackKeys.find(
                                            j => j.uid === e.target.value
                                        );
                                        this.setState({
                                            ...this.state,
                                            jobID: result.uid,
                                            jobName: result.client_name
                                        });
                                    }}
                                    input={
                                        <Input
                                            name="jobpack-id"
                                            id={`jobpack-id`}
                                        />
                                    }
                                >
                                    {Array.isArray(this.props.jobpackKeys) &&
                                        this.props.jobpackKeys.map((e, i) => {
                                            return (
                                                <MenuItem key={i} value={e.uid}>
                                                    {e.uid}
                                                </MenuItem>
                                            );
                                        })}
                                </Select>
                            </TextInputContainer>
                            {/* 
                            <TextInputContainer row={1}>
                                <TextField
                                    key={"rowTitle"}
                                    id="outlined-name"
                                    label="Job ID"
                                    value={this.state.jobID}
                                    placeholder="6-digits e.g. 123456"
                                    onChange={e => {
                                        this.handleChange(e, "jobID");
                                    }}
                                    margin="normal"
                                    variant="outlined"
                                    onKeyPress={event => {
                                        if (event.key === "Enter") {
                                            this.props.handleClose();
                                        }
                                    }}
                                />
                            </TextInputContainer> */}
                            <TextInputContainer row={2}>
                                <TextField
                                    key={"rowTitle"}
                                    id="outlined-name"
                                    label="Job Name"
                                    value={this.state.jobName}
                                    onChange={e => {
                                        this.handleChange(e, "jobName");
                                    }}
                                    margin="normal"
                                    variant="outlined"
                                    onKeyPress={event => {
                                        if (event.key === "Enter") {
                                            this.props.handleClose();
                                        }
                                    }}
                                />
                            </TextInputContainer>
                            {this.getEmployeeSelect("employee1", 3)}
                            {this.getEmployeeSelect("employee2", 4)}
                            {this.getEmployeeSelect("employee3", 5)}
                            {this.getEmployeeSelect("employee4", 6)}
                        </EditDayContainer>
                    </CardContent>
                    <CardActions
                        className={classes.actions}
                        disableActionSpacing
                    >
                        <Button
                            className={classes.button}
                            onClick={() => {
                                this.props.setDayData(
                                    this.props.eventRowIndex,
                                    this.props.dayCellIndex,
                                    this.state
                                );
                                this.props.handleClose();
                            }}
                        >
                            Save
                        </Button>
                        <Button
                            className={classes.button}
                            onClick={() => {
                                this.setState({
                                    jobName: "",
                                    jobID: "",
                                    employee1: "",
                                    employee2: "",
                                    employee3: "",
                                    employee4: ""
                                });

                                this.props.clearTempUserPosition(
                                    this.props.dayCellIndex
                                );
                            }}
                        >
                            Clear
                        </Button>
                        <Button
                            className={classes.button}
                            onClick={() => {
                                this.props.copyUserPositionsToTempUserPositions();
                                this.props.handleClose();
                            }}
                        >
                            Cancel
                        </Button>
                    </CardActions>
                </Card>
            </Modal>
        );
    }
}

export default hot(module)(
    withStyles(styles)(
        connect(
            (store, props) => {
                return {
                    usernames: selectUserNames(store),
                    userPositions: selectTempUserPositionsForDay(
                        props.dayCellIndex
                    )(store),
                    jobpackKeys: selectJobpackKeys(store)
                };
            },
            {
                setEventRowTitle,
                setDayData,
                setTempUserPosition,
                copyUserPositionsToTempUserPositions,
                clearTempUserPosition
            }
        )(EditDayCellModal)
    )
);
